import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import { AmpSophi, AmpSophiProps } from './AmpSophi'

export const AmpSophiRegistration = createRegisterableComponent(
    'amp-sophi',
    (props: AmpSophiProps) => {
        return <AmpSophi {...props} />
    },
)
